import { Zap, Flame, Droplets, Truck, BatteryCharging, Leaf, Wheat, HeartPulse } from "lucide-react";

export const navLinks = [
  { label: "Industries", href: "#industries" },
  { label: "Get Involved", href: "#join" },
  { label: "Contact", href: "#contact" },
];

export const heroContent = {
  headline: "Where Industry Leaders",
  headlineAccent: "Converge",
  subline: "",
  subtext:
    "With over 15 years of experience, IQ Hub brings together senior executives, innovators, and decision-makers across 8 industries. Our curated conferences spark the conversations that drive real-world progress.",
};

export const industries = [
  {
    id: 1,
    name: "Energy & Power",
    icon: Zap,
    description: "Powering the transition to sustainable, reliable energy systems worldwide.",
  },
  {
    id: 2,
    name: "Oil & Gas",
    icon: Flame,
    description: "Driving efficiency and innovation across upstream, midstream, and downstream operations.",
  },
  {
    id: 3,
    name: "Water & Utilities",
    icon: Droplets,
    description: "Building smarter, more resilient water infrastructure for growing communities.",
  },
  {
    id: 4,
    name: "Transportation & EV",
    icon: Truck,
    description: "Accelerating the shift to electrified, autonomous, and connected mobility.",
  },
  {
    id: 5,
    name: "Battery & Materials",
    icon: BatteryCharging,
    description: "Advancing energy storage and critical materials for a decarbonized future.",
  },
  {
    id: 6,
    name: "Decarbonization",
    icon: Leaf,
    description: "Scaling the technologies needed to reach net-zero across every sector.",
  },
  {
    id: 7,
    name: "Agriculture & Food",
    icon: Wheat,
    description: "Transforming food systems through precision technology and sustainable practices.",
  },
  {
    id: 8,
    name: "Pharma & Healthcare",
    icon: HeartPulse,
    description: "Pioneering next-generation therapeutics, diagnostics, and digital health solutions.",
  },
];

export const stats = [
  { value: "15+", label: "Years of Experience" },
  { value: "8", label: "Industry Verticals" },
  { value: "3000+", label: "Organizations" },
  { value: "125", label: "Annual Conferences" },
];

export const joinCards = [
  {
    id: 1,
    title: "Delegates",
    subtitle: "Be Part of the Conversation",
    description:
      "Gain exclusive access to curated sessions, panel discussions, and networking opportunities with senior industry leaders.",
    image: "https://images.unsplash.com/photo-1550305080-4e029753abcf?w=600&h=400&fit=crop",
  },
  {
    id: 2,
    title: "Speakers",
    subtitle: "Share Your Expertise",
    description:
      "Present your insights, research, and innovations to an engaged audience of decision-makers and thought leaders.",
    image: "https://images.unsplash.com/photo-1523580494863-6f3031224c94?w=600&h=400&fit=crop",
  },
  {
    id: 3,
    title: "Exhibitors",
    subtitle: "Showcase Your Brand",
    description:
      "Position your solutions in front of qualified buyers and forge partnerships that drive business growth.",
    image: "https://images.unsplash.com/photo-1571645163064-77faa9676a46?w=600&h=400&fit=crop",
  },
  {
    id: 4,
    title: "Partners",
    subtitle: "Amplify Your Reach",
    description:
      "Collaborate with IQ Hub to co-create thought leadership content and extend your brand across our global network.",
    image: "https://images.unsplash.com/photo-1675716921224-e087a0cca69a?w=600&h=400&fit=crop",
  },
];

export const insights = [
  {
    id: 1,
    title: "The Rise of Direct Lithium Extraction Technologies",
    category: "Battery & Materials",
    date: "January 2026",
    excerpt:
      "DLE technologies are reshaping the lithium supply chain, offering faster extraction with lower environmental impact across South America and beyond.",
    image: "https://images.unsplash.com/photo-1560439514-4e9645039924?w=600&h=400&fit=crop",
  },
  {
    id: 2,
    title: "AI-Powered Water Networks: Reducing Leakage by 40%",
    category: "Water & Utilities",
    date: "December 2025",
    excerpt:
      "Smart sensors and machine learning are transforming how utilities detect and prevent water loss across aging infrastructure.",
    image: "https://images.unsplash.com/photo-1523580494863-6f3031224c94?w=600&h=400&fit=crop",
  },
  {
    id: 3,
    title: "Scaling Carbon Capture: From Pilot to Commercial",
    category: "Decarbonization",
    date: "November 2025",
    excerpt:
      "With policy support growing globally, CCUS projects are finally moving from demonstration to full-scale commercial deployment.",
    image: "https://images.unsplash.com/photo-1550305080-4e029753abcf?w=600&h=400&fit=crop",
  },
];

export const globalLocations = [
  "🇺🇸 Houston, TX",
  "🇺🇸 Los Angeles, CA",
  "🇺🇸 San Diego, CA",
  "🇺🇸 Orange County, CA",
  "🇺🇸 Anaheim, CA",
  "🇺🇸 Detroit, MI",
  "🇺🇸 Boston, MA",
  "🇺🇸 Chicago, IL",
  "🇺🇸 Miami, FL",
  "🇺🇸 Phoenix, AZ",
  "🇺🇸 Washington, DC",
  "🇬🇧 London, UK",
  "🇩🇪 Munich, Germany",
  "🇩🇪 Frankfurt, Germany",
  "🇳🇱 Amsterdam, Netherlands",
  "🇳🇴 Stavanger, Norway",
  "🇪🇸 Madrid, Spain",
  "🇫🇷 Paris, France",
  "🇧🇪 Brussels, Belgium",
  "🇦🇪 Dubai, UAE",
  "🇦🇺 Melbourne, Australia",
  "🇦🇺 Perth, Australia",
  "🇨🇦 Calgary, Canada",
  "🇨🇦 Toronto, Canada",
  "🇨🇦 Vancouver, Canada",
  "🇧🇷 São Paulo, Brazil",
  "🇦🇷 Buenos Aires, Argentina",
  "🇸🇬 Singapore",
];
